import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Tables } from "database.types";
import {
  marketHistoryWindow,
  variantMarketHistory,
} from "@/components/pricing/history";

interface Props {
  variant: Tables<"variants"> & { condition: Tables<"conditions"> };
}
export function CardDetailsModalStats({ variant }: Props) {
  const history = variantMarketHistory(variant.raw);
  const periods = [7, 30, 90].map((days) => ({
    days,
    window: marketHistoryWindow(history, days),
  }));
  return (
    <Card>
      <CardHeader>
        <h3 className="text-lg font-semibold">Recorded market-guide history</h3>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-xs text-muted-foreground">
          Historical provider prices for this variant; not individual completed
          sales.
        </p>
        {periods.map(({ days, window }) => (
          <div key={days} className="flex justify-between gap-3">
            <span className="text-muted-foreground">{days}-day change:</span>
            <span className="font-medium">
              {window
                ? `${window.changePercent > 0 ? "+" : ""}${window.changePercent.toFixed(2)}%`
                : "Not available"}
            </span>
          </div>
        ))}
        {!periods.some((period) => period.window) && (
          <p className="text-xs text-muted-foreground">
            Insufficient recorded history for period comparisons.
          </p>
        )}
      </CardContent>
    </Card>
  );
}
